module.exports = __webpack_public_path__ + "img/Flag_of_Turkey.b69ba9f7.svg";